const state = () => ({
  certifications: {},
});

const getters = {
  certifications: state => state.certifications,
  certificationsList: state => Object.keys(state.certifications).map(id => state.certifications[id]),
};

const mutations = {
  setCertifications(state, certifications) {
    for (let certification of certifications) {
      state.certifications[certification.id] = certification;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
